'use strict';

var dictionary = {
  E: 'OOFF',
  M: 'MNTH',
  K: 'QRTR',
  H: 'HFYR',
  J: 'YEAR'
};

module.exports = function (key) {
  return dictionary[key];
};
